import { TextField } from '@mui/material'
import React from 'react'
import InputMask from 'react-input-mask'

export default function PhoneInput (props) {
  return (
    <InputMask
      mask='9999999999'
      maskChar={null}
      value={props.value}
      onChange={props.onChange}
    >
      {() => <TextField {...props} placeholder='1234567890' />}
    </InputMask>
  )
}

// import { TextField } from '@mui/material'
// import React from 'react'
// import InputMask from 'react-input-mask'

// export default function PhoneInput (props) {
//   const { value, onChange, ...otherProps } = props

//   return (
//     <InputMask
//       mask='999-999-9999' // Define the mask
//       value={value}
//       onChange={onChange} // Pass the onChange handler directly
//     >
//       {inputProps => (
//         <TextField {...otherProps} {...inputProps} placeholder='123-456-7890' />
//       )}
//     </InputMask>
//   )
// }
